import { typedPageSelectors, usePage } from 'publisher/store'
import React from 'react'
import { CommonPublisherButtonEntityOrSubEntity } from 'src/publisher/shared/components/button/common-publisher-button-entity-or-sub-entity'
import { RegistrationButtonEntityInterface } from 'src/shared/entities/registration-button/registration-button-entity.schema'

const TEST_ID = 'registration-button'

export interface RegistrationButtonProps {
  entity: RegistrationButtonEntityInterface
}

export const RegistrationButton = ({ entity }: RegistrationButtonProps) => {
  const locale = usePage(state => typedPageSelectors.getLocale(state))

  return (
    <CommonPublisherButtonEntityOrSubEntity
      entityOrSubEntity={entity}
      onClick={() => {
        location.assign(`/${locale}/register`)
      }}
      testId={TEST_ID}
    />
  )
}
